export const fertilizersData = [
  {
    id:1,
    name: "جرين ماس",
    comp:"W/W",
    cat:"أسمدة",
    img:"/assets/Products/1.webp",

    composition: {
      "نيتروجين كلي (N₂O)": "19%",
      "فوسفور (P₂O₅)": "19%",
      "بوتاسيوم (K₂O)": "19%"
    },
    features: [
      "تركيبة متوازنة ومتكاملة من العناصر الكبري المغذية الضرورية للنبات.",
      "سماد عالي النقاء تام الذوبان في الماء بنسبة ١٠٠٪ ومصنع بتكنولوجيا عالية.",
      "يساعد علي بناء مجموع خضري قوي في بداية عمر النبات.",
      "يعمل علي زيادة نسبة التزهير والعقد وتوحيد النضج وتحسين جودة الثمار.",
      "يعمل علي زيادة تحمل ومقاومة النبات لظروف الإجهاد المختلفة."
    ],
    usageRates: {
      "التسميد الأرضي": "3-5 كجم / فدان",
      "الرش الورقي": "1.5-3 كجم / 600 لتر ماء"
    },
    mixing: "يقبل الخلط مع معظم أنواع الأسمدة والمبيدات ماعدا المركبات التي تحتوي علي الكالسيوم والنحاس والمحاليل ذات الوسط القلوي ويفضل عمل تجربة قبل الخلط.",
    registrationNumber: "5811 / 1"
  },
  {
    id:2,
    name: "جرين ماس VIP",
    comp:"W/W",

    cat:"أسمدة",
    img:"/assets/Products/2.webp",

    composition: {
  "نيتروجين كلي (N₂O)": "9%",
    "فوسفور (P₂O₅)": "53%",
    "بوتاسيوم (K₂O)": "5%",
    "مغنيسيوم (Mg)": "1%",
    "كبريت (S)": "1.2%"
    },
    features: [
      "مركب ذو كفاءة عالية لما يحتويه علي نسبة عالية من الفوسفور بالإضافة الي نسبة مدروسة من عنصري النيتروجين والبوتاسيوم.",
      "يحتوي علي عنصر الماغنسيوم الذي يساهم بشكل اساسي في عملية التمثيل الضوئي وبناء الكلوروفيل. ",
      "يساعد علي انتشار ونمو الجذور .",
      "يعمل علي زيادة تحمل ومقاومة النبات لظروف الإجهاد المختلفة .",
      "سماد خالي من مركبات الكلور والصوديوم والمعادن الثقيلة . ",
      "سماد عالي النقاء تام الذوبان في الماء بنسبة ١٠٠٪"
    ],
    usageRates: {
      "التسميد الأرضي": "2-4 لتر / فدان",
      "الرش الورقي": "150-250 سم³ / 100 لتر ماء"
    },
    mixing: "يقبل الخلط مع معظم أنواع الأسمدة والمبيدات ماعدا المركبات التي تحتوي علي الكالسيوم والنحاس والمحاليل ذات الوسط القلوي ويفضل عمل تجربة قبل الخلط .",
    registrationNumber: "5836 / 1"
  },
  {
    id:3,
    name: "ملجراند ماب",
    comp:"W/W",
    cat:"أسمدة",

    img:"/assets/Products/3.webp",
    composition: {
      "نيتروجين (N)": "12%",
      "فوسفور (P₂O₅)": "61%"
    },
    features: [
    "هو سماد مركب عالي الفوسفور و يحتوي على نسبة من النيتروجين ، في صورة بودر تام الذوبان في الماء",
    "يتميز بتركيبته المتطورة التي تلبي احتياجات النبات من الفوسفور لفترات طويلة",
    "بفضل تركيزه العالي من الفوسفور؛ فهو يدعم تكوين جذور قوية وصحية",
    "يساعد على زيادة عدد الأزهار وتحسين جودة الثمار.",
    "يساعد على تحسين امتصاص العناصر الغذائية الأخرى.",
    "مناسب لمجموعة واسعة من المحاصيل، بما في ذلك المحاصيل الحقلية، الخضروات، والفواكه",
    ],
    usageRates: {
      "تسميد بالتربة" : "يخلط السماد مع ماء الري بجرعات تتناسب مع احتياجات النبات",
      "التسميد الورقي": "يستخدم بجرعات مخففة للرش على الأوراق لضمان امتصاص سريع للفوسفور",
      "التسميد الأرضي": "2 – 5 كجم / فدان",
      "الرش الورقي": "250 – 500 جرام / 100 لتر"
    },
    mixing: "يقبل الخلط مع معظم أنواع الأسمدة والمبيدات ويفضل عمل تجربة قبل الخلط.",
    registrationNumber: "27094"
  },
  {
    id:4,
    name: "ميثوفاك",
    comp:"W/W",

    cat:"أسمدة",
    img:"/assets/Products/4.webp",

    composition: {
      "نيتروجين (N₂O)": "10%",
      "فوسفور (P₂O₅)": "5%",
      "بوتاسيوم (K₂O)": "40%",
      "كبريت (S)": "13%"
    },
    features: [
      "مصدر أساسي لعنصر البوتاسيوم الذي يحتاجه النبات بكميات كبيرة",
      "سماد عالي النقاء خالي من الكلوريد وذو كفاءة عالية",
      "تام الذوبات في الماء بنسبة ١٠٠٪ وصالح للإستخدام في كافة أنظمة الري",
      "يعمل علي تقوية جذر الخلايا ويساعد علي وقاية النبات من الأمراض المختلفة ",
      "يساعد علي نضج الثمار وزيادة نسبة التلوين",
      "يساعد علي زيادة حجم الثمار وزيادة نسبة السكريات بها ",
    ],
    usageRates: {
      "التسميد الأرضي": "2-3 كجم / فدان",
      "الرش الورقي": "1.5-2 كجم / 600 لتر ماء"
    },
    mixing: "يقبل الخلط مع معظم أنواع الأسمدة والمبيدات ماعدا المركبات التي تحتوي علي الكالسيوم والنحاس والمحاليل ذات الوسط القلوي ويفضل عمل تجربة قبل الخلط.",
    registrationNumber: "8652"
  },
  {
    id:5,
    name: "جولدن فاك",
    comp:"W/V",
    cat:"أسمدة",

    img:"/assets/Products/5.webp",
    composition: {
      "فوسفور (P₂O₅)": "33%",
      "بوتاسيوم (K₂O)": "44%",
      "ستريك أسيد  - (Citric Acid)": "2%",
      "اسكروبيك أسيد  - (Scorbic Acid)": "8%"
    },
    features: [
      "يزيد من انتشار المجموع الجذري ومقاومته للأمراض الفطرية والنيماتودا ",
      "يعمل علي زيادة كفاءة الجهاز المناعي الطبيعي للنبات ويزيد من قدرته علي مقاومة الكائنات الممرضة ",
      "يساعد النباتات علي زيادة معدل التزهير والعقد وتحسين جودة الثمار ",
      "يزيد من تكوين السكريات و البروتينات وزيادة حجم الثمار",
      "يزيد من مقاومة النباتات لظروف الإجهاد المعاكسة ( الحرارة العالية - الصقيع - الجفاف - الأفات– الرياح)",
    ],
    usageRates: {
      "التسميد الأرضي": "1.5-2 لتر / فدان مع ماء الري",
      "الرش الورقي": "600 سم / 600 لتر ماء"
    },
    notes: [
      "مواعيد الرش المناسبة عند بداية الإزهار والعقد وبعد العقد."
    ],
    mixing: "يقبل الخلط مع معظم الأسمدة والمبيدات ماعدا المركبات التي تحتوي على الكالسيوم والنحاس والمبيدات الفسفورية ويفضل عمل تجربة قبل الخلط.",
    registrationNumber: "10665"
  },
  {
    id:6,
    name: "جراند سايز",
    comp:"W/V",
    cat:"أسمدة",

    img:"/assets/Products/6.webp",
    composition: {
      "بوتاسيوم (K₂O)": "36%",
      "كبريت (S)": "25%"
    },
    features: [
      "مركب ذو كفاءة عالية نتيجة استبدال ذرة الكبريت محل ذرة أكسچين مما يضاعف تأثيره علي النبات ",
      "يمكن استخدامه كسماد بوتاسي وأيضا كبريتي لسد احتياجات النبات",
      "مهم جدا لمرحلة الإثمار لإحتواءه علي عنصر البوتاسيوم",
      "يساعد في تكوين النشا في البذور والبروتينات في النبات ورفع نسبة السكريات وزيادة التلوين في الثمار",
      "يستخدم لزيادة نسبة العقد والإزهار في المحاصيل المختلفة",
      "خالي من عنصر الكلور الضار واحتوائه علي عنصر الكبريت في صورة ثيوسلفاتية التي لها تأثير وقائي من العديد من الفطريات الضارة مثل البياض الدقيقي",
      "يستخدم جراند سايز مع جميع أنواع الأراضي وكافة أنظمة الري",
    ],
    usageRates: {
      "الخضروات  (طماطم - بطاطس - خيار - بطيخ - بنجر السكر ) " : "500 سم / 200 لتر ماء",
      "المحاصيل الحقلية (ارز-ذرة-قمح-فول-قطن)": "500 سم / 200 لتر ماء",
      "البيوت المحمية والصوب": "500 سم / 200 لتر ماء",
      "الأشجار المثمرة والفاكهة": "500 سم / 200 لتر ماء",
      "الرش الورقي": "500 سم / 200 لتر ماء",
      "كما يمكن": " استخدام جراند سايز 2 لتر / فدان حقنًا مع ماء الري" 
    },
    mixing:"قابل للخلط مع جميع الأسمدة والمبيدات فيما عدا المركبات الفسفورية حامضية التأثير و يفضل إجراء تجربة قبل الخلط . و يفصل إضافة جراند سايز الي الماء اولا في حالة الخلط ثم اضافة الاسمدة والمبيدات المراد استخدامها ويفضل رشه فى الصباح الباكر او في المساء ",
    registrationNumber: "10666"
  },
  {
    id:7,
    name: "ملجراند نتروكال",
    comp:"W/W",
    cat:"أسمدة",

    img:"/assets/Products/7.webp",
    composition: {
      "نيتروجين (N)": "15.5%",
      "كالسيوم (Ca)": "18.5%"
    },
    features: [
        "يوفر الكالسيوم وهو عنصر غذائي أساسي في تكوين جدران الخلايا داخل النبات، فيمنحه قوة واستقرارًا أكبر مما يزيد من مقاومة النبات للأمراض",
      "يحتوي على النيتروجين المتاح بسهولة والذي تمتصه النباتات بسرعة ",
      "يساعد على تكوين فروع جديدة في النباتات، وتطور الإزهار والثمار، ويمنع تساقط الثمار ",
      "يساعد في تكوين البروتينات عن طريق زيادة النترات الممتصة من قبل النبات عند إضافة أسمدة نيتروجينية في صورة نترات.",
      "يعمل على تنشيط الأنسجة المريستيمية في القمم النامية كما يشجع نمو وامتداد الجذور وخصوصا الشعيرات الجذرية.",
      "يساعد في الحفاظ على بنية التربة ؛ لأنه يقلل من خطر التملح وتفكك التربة، خاصة عند استخدام المياه المالحة للري .",
    ],
    usageRates:  "2-3 كجم/فدان لجميع أنواع المحاصيل ",
    mixing: "يقبل الخلط مع معظم أنواع الأسمدة والمبيدات ماعدا الفوسفات والكبريت، ويفضل التجربة قبل الخلط.",
    registrationNumber: "27093"
  },
  {
    id:8,
    name: "هيومي مارك",
    comp:"W/W",
    cat:"أسمدة",

    img:"/assets/Products/8.webp",
    composition: {
      "بوتاسيوم (K₂O)": "10% (مصدره هيومات بوتاسيوم)"
    },
    features: [
      "يزيد من حجم الثمار مع الحفاظ على لون وطعم مميزين .",
      "يعمل علي سرعة وكفاءة انتشار الجذور مما يساعد علي تكوين مجموع خضري قوي ",
      "يزيد من معدل تكوين الشعيرات الجذرية الجانبية مما يرفع من معدل امتصاص العناصر الغذائية ",
      "يعمل علي خفض تساقط الأزهار وتحسين العقد",
      "يعمل على تيسير العناصر الغذائية ويقلل من الاثار الضارة للملوحة  فى التربة على النبات ",
      "يزيد من تحمؔل النبات للظروف البيئية الغير ملائمة",
      "يساعد البوتاسيوم في انتقال الكربوهيدرات من أماكن التخليق الى الأجزاء الأخرى في النبات، ويعمل على حفظ بناء البروتينات ونفاذية الاغشية",
    ],
    usageRates: {
      "الرش الورقي": "250جم -500 جم/فدان",
      "الري": "1-2 كجم/فدان"
    },
    registrationNumber: "8653"
  },
  {
    id:9,
    name: "فوسفوريك البركة 85 ",
    comp:"W/V",
    cat:"أسمدة",

    img:"/assets/Products/9.webp",
    composition: {
      "حامض الفوسفوريك (H₃PO₄)": "85%"
    },
    features: [
      "يتميز فوسفوريك البركة 85 بسهولة ذوبانه في الماء واحتواءه علي تركيز عالي من عنصر الفوسفور وتأثيره علي خفض رقم PH مياه الري والتربة وهذه المميزات مطلوبة بدرجة كبيرة في الزراعة تحت ظروف الأراضي المصرية القلوية والأراضي الجيرية .",
      "يزيد من تقوية جذور النبات ويساعد علي نشاطها  ",
      "يساعد في عملية البناء والهدم داخل الخلايا النباتية ",
      "يساعد في تنشيط الإزهار وزيادة نسبة عقد الثمار ",
      "يستخدم حمض الفوسفوريك كسماد خلال مياه الري كمصدر أساسي للفوسفور اللازم لنمو النباتات",
      "خال تماما من المعادن الثقيلة والضارة مثل الرصاص ",
      "يستخدم في تنظيف الرشاشات وخراطيم التنقيط وبتركيز معين ",
    ],
    usageRates:"2-3 لتر/فدان",
    mixing: "يقبل الخلط مع معظم أنواع الأسمدة والمبيدات ماعدا المحتوية علي سلفات المغنيسيوم والهيومك ونترات الكالسيوم ويفضل عمل تجربة قبل الخلط ",
    registrationNumber: "14740 / 1"
  },
  {
    id:10,
    name: "هانفوهيوميت",
    comp:"W/W",
    cat:"أسمدة",

    img:"/assets/Products/10.webp",
    composition: {
      "بوتاسيوم (K₂O)": "12% (مصدره هيومات بوتاسيوم 85%)"
    },
    features: [
      "يحتوي علي نسبة البوتاسيوم١٢٪ مصدرها هيومات البوتاسيوم والتي تعمل بكفاءة علي انتقال الغذاء من أماكن تخزينها في الثمار.",
      "البوتاسيوم يعمل علي تنشيط العناصرالصغري والإبقاء علي الصبغة الخضراء بالأوراق لفترات طويلة وذلك لضمان سريان عملية انتقال الغذاء ",
      "يعمل هانفوهيوميت علي خفض تساقط الأزهار وتحسين العقد ",
      "يعمل علي ⁠زيادة امتصاص العناصر الغذائية الأخري ",
      "يعمل علي  زيادة تحمل النبات للظروف الغيرملائمة ",
    ],
    usageRates: {
      "الرش الورقي": "500 جم - 1 كجم /فدان",
      "في حالة الري": "1-2 كجم /فدان"
    },
    mixing: "يقبل الخلط مع معظم أنواع الأسمدة والمبيدات ماعدا المحتوية علي الكالسيوم والحديد والمركبات الحامضية ويفضل عمل تجربة قبل الخلط ",
    registrationNumber: "1/5181"
  },
  {
    id:11,
    name: "بي كال جي",
    cat:"أسمدة",

    img:"/assets/Products/11.webp",
    features: [
      "تركيبة فريدة تحتوي على الكالسيوم والماغنيسيوم والبورون بنسب متوازنة تضمن سرعة الامتصاص والانتقال داخل النبات ",
      "يقلل بي كال جي من ظاهرة القلب الأجوف والتشققات في البطاطس والبنجر",
      "الكالسيوم يزيد من صلابة الثمار مما يعمل على زيادة من فترة التخرين",
      "الماغنسيوم يعمل على تحفيز الكلوروفيل داخل الخلايا مما يزيد من كفاءة عملية البناء الضوئي",
      "يعمل الكالسيوم والبورون علي زيادة نسبة العقد وزيادة تثبيت الازهار",
      "يعمل على علاج أي خلل ينتج عن نقص عنصر الكالسيوم مثل عفن الطرف الزهري في الخضروات والقرعيات ",
      "يساعد علي مقاومة النبات للظروف البيئية الصعبة ( برودة- صقيع- الحرارة العالية )",
      "يحفز المجموع الجذري علي زيادة الانتشار والنمو عند اتسخدامه حقنا في الجذور ",
    ],
    usageRatesExtra: {
      "الخضروات": {
        "الرش الورقي": "150-250 سم³ / 100 لتر",
        "التسميد": "1.5 لتر/فدان حقنا مع ماء الري"
      },
      "القرعيات": {
        "الرش الورقي": "150-250 سم³ / 100 لتر",
        "التسميد": "1.5 لتر/فدان حقنا مع ماء الري"
      },
      "محاصيل الحبوب": {
        "الرش الورقي": "150-250 سم³ / 100 لتر",
        "التسميد": "1.5 لتر/فدان حقنا مع ماء الري"
      },
      "أشجار الفاكهة": {
        "الرش الورقي": "150-250 سم³ / 100 لتر",
        "التسميد": "1.5 لتر/فدان حقنا مع ماء الري"
      }
    },
    mixing: "لا يخلط مع مركبات النحاس والمبيدات الفسفورية.",
    registrationNumber: "14395"
  },
  {
    id:12,
    name: "بروفاك",
    comp:"W/V",
    cat:"أسمدة",

    img:"/assets/Products/12.webp",
    composition: {
      "بورون (B)": "15% (مصدره بورون إيثانول أمين)"
    },
    features: [
      "يستخدم لسد حاجة النبات من عنصر البورون وخصوصاً في مرحلة صب الدرنات في البطاطس أو في مرحلة تضخم الجذور في المحاصيل الجذرية مثل البنجر ومحاصيل الحقل ومحاصيل الخضر التي تدفع التزهير علي مراحل",
      "يعطي نمو سليم متوازن للنبات عن طريق تحفيز نمو وانقسام القمم المرستيمية الموجودة في قمم البراعم النامية خضرية أو زهرية والجذور والدرنات ",
      "يساعد علي تكوين أنسجة قوية لنقل الماء والعناصر الغذائية والمركبات العضوية",
      "يزيد من سرعة تكوين وتراكم السكريات في المحاصيل السكرية مثل البنجر وقصب السكر والعنب ومعظم أنواع الفاكهة",
      "يزيد من خصوبة وحيوية حبوب اللقاح ولزوجة مياسم الأزهار مما يزيد من الإخصاب وتقليل تساقط الأزهار والثمار وثبات العقد ",
    ],
    usageRates: {
      "التسميد الأرضي": "يضاف بمعدل  1-2 لتر/فدان",
      "الرش الورقي": " يضاف بمعدل 0.5-1 سم³/لتر ماء"
    },
    mixing: "يقبل الخلط مع معظم الأسمدة والمبيدات ويفضل تجربة قبل الخلط.",
    registrationNumber: "8629"
  },
  {
    id:13,
    name: "ميكرو كومبي 2",
    comp:"W/W",
    cat:"أسمدة",

    img:"/assets/Products/13.webp",
    composition: {
      "زنك (Zn)": "3%",
      "ماغنسيوم (Mg)": "3%",
      "حديد (Fe (EDTA))": "2.5% ",
      "منجنيز (Mn (EDTA))": "2% ",
      "بورون (B)": "1.7%",
      "نحاس (Cu)": "0.8%",
      "كبريت (S)": "5.84%",
      " مركب (EDTA)": "22.5%"
    },
    features: [
      "يحتوى على خليط متوازن من العناصر الصغري عالية النقاوة والجودة وفي صورة مخلبة علي اديتا ",
      "تام الذوبان في الماء مما يزيد من كفاءة الامتصاص من قبل النبات",
      "يحسن من نمو النبات خاصة في المراحل الأولى من النمو كما يساعد على الاتزان الهرموني الداخلي للنبات ",
      "يعمل كمنشط لكثير من الإنزيمات وتخليق العديد من منظمات النمو والأحماض النووية اللازمة لانقسام وزيادة حجم الخلايا ",
      "يزيد من قدرة النبات على تحمل ظروف الإجهاد المختلفة (حرارة عالية – صقيع- رياح جافة -الملوحة العالية) ",
    ],
    usageRates: {
      "التسميد الأرضي": "1-1.5 كجم/فدان",
      "الرش الورقي": "يضاف بمعدل0.5-1 كجم / فدان على ألا يقل كمية مياه الرش عن 400 لتر ماء / فدان"
    },
    mixing: "يقبل الخلط مع معظم الأسمدة والمبيدات ويفضل تجربة قبل الخلط.",
    registrationNumber: "27092"
  }
];

export const pgrsData = [
  {
    id: 1,
    name: "فيرو روكيت",
    comp:"W/V",
    cat:"منظمات النمو",

    img:"/assets/Products/ن1.webp",
    composition: {
      "جبريلك اسيد (GA3)": "1.35%",
      "اندول استيك اسيد (IAA)": "1%",
      "كاينتين (Kinetin)": "0.5%"
    },
    features: [
      "فيرو روكيت ...عبارة عن خليط متوازن من ثلاثة أنواع من منظمات النمو النباتية و الاوكسينات",
      "يعمل علي تنشيط نمو النبات ودفعها للتزهير و زيادة نسبه العقد و تحسين جوده الثمار مما ينعكس بدوره على رفع إنتاجية وجودة المحاصيل ",
      "يمنع التشوهات الزهرية والثمرية ويمنع ظاهرة عدم امتلاء الثمار ",
      "يعمل علي توحيد النضج وزيادة نسبة السكر",
      "زيادة معدل التزهير وخصوبة وحيوية حبوب اللقاح والتسريع في نمو الثمار . ",
      "فيرو روكيت ...يعمل علي تعزيز انقسام الخلايا من الأنسجة meristematic",
      "يلعب دورا مهما في تلوين جذر الخلايا وعملية انقسام الخلايا",
    ],
    usageRates: {
      "الفاكهة (عنب – تفاح – مانجو – فراولة)": "60 سم³ / 600 لتر ماء",
      "محاصيل الخضر (بطاطس – طماطم – بنجر – خيار – بطيخ)": "60 سم³ / 600 لتر ماء",
      "المحاصيل الحقلية (قمح – أرز – ذرة – قطن)": "60 سم³ / 600 لتر ماء"
    },
    mixing: null,
    registrationNumber: "11260"
  },
  {
    id: 2,
    name: "جبر سنت",
    comp:"W/W",
    cat:"منظمات النمو",

    img:"/assets/Products/ن2.webp",
    composition: {
      "جبريلك أسيد (GA3)": "10%"
    },
    features: [
      "جبر سنت عبارة عن اقراص من الجبريلين (جبريلك أسيد10% ) قابلة للذوبان في الماء بنسبة 100% بمكونات نشطة و أكثر استقرارًا",
      "جبر سنت يساعد في دفع النبات الي التزهير والعقد المبكر وزيادة حجم الثمار و استطالة السلاميات واطالة فترة التخزين علي الاشجار",
      "الجبريلك أسيد هو منظم نمو طبيعي يتم إفرازه داخل النبات حيث يساعد علي الاسراع من عملية نمو الخلايا والبراعم والأوراق ",
      "يعمل الجبريلك اسيد كمنظم نمو علي كسر طور السكون في البذور حيث يحل محل درجات الحرارة الباردة أو الضو الاحمر او الظلام وهي المؤثرات التي تسبب انبات البذور . ",
      "يؤثر الجبريلك علي كسر طور السكون في براعم كثير من النباتات متساقطة الأوراق التي تحتاج الي شتاء منخفض الحرارة ونهار طويل لكي تنمو في الربيع.",
    ],
    usageRatesExtra: {
      "العنب": {
        "مرحلة استطالة العناقيد": "قرص / 100 لتر ماء",
        "مرحلة خف العناقيد": "2 قرص / 100 لتر ماء",
        "مرحلة زيادة حجم الثمار": "4 قرص / 100 لتر ماء"
      },
      "البرتقال": {
        "عند بداية تغيير لون الثمار من الأخضر إلى الأصفر": "قرص / 100 لتر ماء"
      },
      "الكمثري": {
        "عند 30% تزهير": "1.5 - 2.5 قرص / 100 لتر ماء"
      },
      "الخوخ والبرقوق": {
        "لزيادة حجم الثمار وتلافي تأثير التجمد": "1.5 - 2.5 قرص / 100 لتر ماء"
      },
      "نباتات الزينة": {
        "لإطالة عمر وكبر حجم الأزهار": "4 - 5 أقراص / 100 لتر ماء"
      },
      "الفراولة": {
        "قبل 3-4 أسابيع من بدء الإزهار": "2.5 - 5 أقراص / 200 لتر ماء"
      },
      "الخرشوف": {
        "عند ظهور 6-8 ورقات على الشتلة": "2 قرص / 100 لتر ماء، ويكرر الرش مرتين كل 3 أسابيع"
      },
      "البطاطا والبطاطس": {
        "نقع التقاوي قبل الزراعة": "1 - 2 قرص / 100 لتر ماء"
      },
      "الفلفل": {
        "قبل التزهير ومرة أخرى بعد 2-3 أسابيع": "3 أقراص / 100 لتر ماء"
      }
    },
    mixing: null,
    registrationNumber: "10745"
  }
];

export const pesticidesData = [
  {
    id: 1,
    name: "الترابروك 5.7%",
    comp:"W/W",
    cat:"مبيدات",

    img:"/assets/Products/م1.webp",
    composition: {
      "إمامكتين بنزوات": "5.7%"
    },
    features: [
    "الترابروك مبيد حشري اختياري ليس جهازي في صورة حبيبات قابلة للبلل حيث يعمل عن طريق الملامسة وكسم معدي ",
    "الترابروك له القدرة على المرور خلال أنسجة النبات وينتقل عبر النسيج الورقي من السطح العلوي الى السطح السفلي ويختزن داخلها، مما يحقق مكافحة طويلة الأمد.",
    "الترابروك الوسيلة الأكيدة لمكافحة العديد من الآفات الحشرية حرشفية الأجنحة، مثل ديدان الأوراق والثمار، وصانعات الأنفاق في مختلف الأعمار.",
    "الترابروك يستخدم على العديد من المحاصيل الحقلية والخضر والفاكهة و متوافق مع برامج المكافحة المتكاملة .",
    ],
    usageRates: {
      "الطماطم": "يستخدم الترابروك لمكافحة دودة ورق القطن علي محصول الطماطم بمعدل 60 جرام/فدان"
    },
    PHI: "٣ أيام",
    mixing: null,
    registrationNumber: "3469"
  },
  {
    id: 2,
    name: "الترامون 48%",
    comp:"W/V",
    cat:"مبيدات",

    img:"/assets/Products/م2.webp",
    composition: {
      "أزوكسي ستروبين": "8%",
      "كلورثالونيل": "40%"
    },
    features: [
      "الترامون مبيد فطري وقائى علاجى وجهازى يتكون من مادتين فعاليتين في صورة مركز معلق",
      "الترامون مقاوم للعديد من الفطريات الممرضة عن طريق منع تقدم الاصابة المرضية وذلك عن طريق منع انبات الجراثيم وهيفات الفطري مما يؤدي في النهاية الي حماية النبات",
      "الترامون له تأثير قوي و متميز فى مقاومة العديد من الأمراض النباتية مثل البياض الزغبى والدقيقى والجرب والندوات ولفحة الساق الصمغية وتبقعات الاوراق علي العديد من المحاصيل الحقلية ونباتات الخضر واشجار الفاكهة",
    ],
    usageRates: {
      "بطيخ اللب (لفحة الساق الصمغية)": "يستخدم الترامون لمكافحة لفحة الساق الصمغية في محصول بطيخ اللب بمعدل ٨٥٠ سم3/ فدان"
    },
    PHI: " ١٠  أيام",
    mixing: null,
    registrationNumber: "4783"
  },
  {
    id: 3,
    name: "التراشوت 24%",
    comp:"W/V",
    cat:"مبيدات",

    img:"/assets/Products/م3.webp",
    composition: {
      "أوكسي فلورفين": "24%"
    },
    features: [
      "التراشوت مبيد عشبي في صورة مركز قابل للاستحلاب",
      "التراشوت يُستخدم بشكل رئيسي لمكافحة الحشائش العريضة والضيقة الأوراق في العديد من المحاصيل الزراعية من الخضروات والفواكه والقطن ونباتات الزينة",
      "التراشوت يُساعد في حماية المحاصيل من الأعشاب الضارة التي تتنافس معها على الماء والغذاء",
      "التراشوت يعمل من خلال ملامسته لأوراق الحشائش، حيث يثبط عملية البناء الضوئي ويؤدي إلى موتها",
      "التراشوت يُستخدم في الظروف البيئية القاسية لانه يظل ثابتاً في التربة؛ وهذا يساعد في تحقيق تأثير طويل الأمد",
      "التراشوت قد يُستخدم أحياناً قبل زراعة المحاصيل، لمنع نمو الحشائش في مراحل الإنبات",
    ],
    usageRates: {
      "الفاكهة ذات النواة الحجرية (الحشائش الحولية)": "-	يستخدم التراشوت لمكافحة الحشائش الحولية عريضة الأوراق والنجيلية على الفاكهة ذات النواة الحجرية بمعدل 1 لتر/فدان عندما تكون الحشائش في طور ٢-٤ورقات ."
    },
    PHI: "الفاكهة ذات النواة الحجرية ٣٠ يوم",
    mixing: null,
    registrationNumber: "4787"
  },
  {
    id: 4,
    name: "التراسينا 48%",
    comp:"W/V",
    cat:"مبيدات",

    img:"/assets/Products/م4.webp",
    composition: {
      "جليفوسيت ايزوبروبيل أمونيوم": "48%"
    },
    features: [
      "1.	الترا سينا ، مبيد حشائش جهازى عام غير إختيارى",
      "يستخدم لمكافحة الحشائش الكلية : الحوليه والمعمرة والنجيلية وعريضة الأوراق النشطة وهي بإرتفاع10-15 سم",
      "يستخدم لمكافحة الحشائش التى تنمو على جسور الترع والمصارف .",
      "يستخدم قبل زراعة محاصيل الخضر والمحاصيل الحقليه ونباتات الزينه",
      "يستخدم تحت أشجارالموالح والعنب والفاكهه بجميع أنواعها",
      "يتم إمتصاصه عن طريق المجموع الخضرى للنبات ويسرى فى العصارة الى الجذور والريزومات للقضاء عليها",
    ],
    usageRates: {
      "الموالح (الحشائش النشطة)": "يستخدم الترا سينا لمكافحة الحشائش الحولية والمعمرة في الموالح بمعدل2.5لتر/فدان ، رشا بالبشبوري TKI بمعدل ١٢٥ لتر ماء /فدان على نموات الحشائش الخضراء النشطة وهي بارتفاع ١٠-١٥ سم"
    },
    PHI: "٣٠ يوم",
    mixing: null,
    registrationNumber: "3595"
  }  
];

export const seedsData = [
  {
    id: 1,
    name: "أرز أصناف مختلفة",
    cat:"بذور",
    img:"/assets/Products/ب1.webp",
  },
  {
    id: 2,
    name: "قمح أصناف مختلفة",
    cat:"بذور",

    img:"/assets/Products/ب2.webp",
  },
  {
    id: 3,
    name: "فول أصناف مختلفة ",
    cat:"بذور",

    img:"/assets/Products/ب3.webp",
  },
  {
    id: 4,
    name: "برسيم مصري بلدي",
    cat:"بذور",

    img:"/assets/Products/ب4.webp",
  }
];